export const listHeaderName = {
  clientName: 'Client Name',
  agents: '# Agents',
  totalTpvs: 'Total TPVs',
  totalIvrMins: 'IVR Mins',
  totalLiveAgentMins: 'Live Agent Mins',
  textTPvs: 'Text TPVs',
  enrollments: 'Enrollments',
  contractSent: 'Contract Sent',
  imageUploaded: 'Image Uploaded',
  totalTexts: 'Total Texts',
}
